import React, { useCallback } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { CButton, CDialog } from '@appcues/component-library';
import { INSTALL_SEGMENT_MODAL } from 'constants/globals';
import { hideModal } from 'actions/currentModal';
import { SEGMENT_INSTALL_DOC } from 'constants/externalAppcuesResources';

const SegmentStylesOverrideBtn = styled.a`
  min-width: 72px;
  display: inline-block;
  padding: 0.5rem 0.875rem;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  text-decoration: none;
  user-select: none;
  outline: none;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  background-color: ${props => props.theme.$green};
  border: 1px solid ${props => props.theme.$green};

  & a {
    background: none !important;
    font-family: inherit !important;
    font-size: inherit !important;
    padding: 0 !important;
    vertical-align: inherit !important;
  }
`;

function Footer({ closeWithCallback }) {
  return (
    <CDialog.Footer>
      <CButton onClick={closeWithCallback}>Cancel</CButton>
      <SegmentStylesOverrideBtn
        target="_blank"
        href={SEGMENT_INSTALL_DOC}
        onClick={closeWithCallback}
      >
        Get Started
      </SegmentStylesOverrideBtn>
    </CDialog.Footer>
  );
}

function InstallSegmentModal({ actions }) {
  const hide = useCallback(() => {
    actions.hideModal(INSTALL_SEGMENT_MODAL);
  }, [actions]);

  return (
    <CDialog
      title="Install with Segment"
      size="large"
      components={{
        Footer: ({ closeWithCallback }) => {
          return <Footer closeWithCallback={closeWithCallback(hide)} />;
        },
      }}
    >
      <p>
        Segment is a third party service that routes data from your app to many
        different services, and gives you central control.
      </p>
      <p>If you already have Segment, you can install Appcues instantly!</p>
    </CDialog>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        hideModal,
      },
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(InstallSegmentModal);
